import { XMarkIcon } from '@heroicons/react/24/outline';
import { Avatar } from '../../Avatar';
import type { RoleMember } from '../../../services/roles';

interface TeamMemberRowProps {
    member: RoleMember;
    /** Omit to hide the remove control entirely (read-only viewers). */
    onRemove?: () => void;
    isRemoving: boolean;
}

export function TeamMemberRow({ member, onRemove, isRemoving }: TeamMemberRowProps) {
    const label = member.fullname || member.email;

    return (
        <div className="flex items-center gap-3 px-3.5 py-2.5 bg-white">
            <div className="w-8 h-8 shrink-0">
                <Avatar user={{ name: member.fullname, email: member.email }} />
            </div>
            <div className="min-w-0 flex-1">
                <p className="text-[13px] font-semibold text-gray-800 truncate">{label}</p>
                <p className="text-[11px] text-gray-500 truncate">{member.email}</p>
            </div>
            {onRemove && (
                <button
                    type="button"
                    onClick={onRemove}
                    disabled={isRemoving}
                    aria-label={`Remove ${label}`}
                    className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-300 hover:text-red-500 hover:bg-red-50 transition-colors disabled:opacity-50 shrink-0"
                >
                    {isRemoving ? (
                        <div className="w-3.5 h-3.5 rounded-full border-2 border-gray-300 border-t-gray-600 animate-spin" />
                    ) : (
                        <XMarkIcon className="h-4 w-4" />
                    )}
                </button>
            )}
        </div>
    );
}
